module.exports = __webpack_public_path__ + "img/pepper.7c1011c4.svg";